// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Units = require("../../helpers/Units.bs.js");
var $dot$dot$slash$dot$dot$slash$dot$dot$slash = require("../../../");
var Core__List = require("@rescript/core/src/Core__List.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var Theme__Color = require("../../../../reason/common/Theme/Theme__Color.bs.js");
var JsxRuntime = require("react/jsx-runtime");

function colorFromType(x) {
  if (x === "unable") {
    return Theme__Color.crimson;
  } else if (x === "ok") {
    return Theme__Color.vidaLoca;
  } else {
    return Theme__Color.stTropaz;
  }
}

var make = $dot$dot$slash$dot$dot$slash$dot$dot$slash.List;

var JS = {
  make: make
};

function List__Jsx3(props) {
  var __type_ = props.type_;
  var type_ = __type_ !== undefined ? __type_ : "bullet";
  return JsxRuntime.jsx(make, {
              items: Core__List.toArray(props.items),
              type: type_ === "unable" ? "unable" : (
                  type_ === "ok" ? "ok-semicircled" : "bullet"
                ),
              iconColor: Units.hex_to_string(Core__Option.getOr(props.iconColor, colorFromType(type_))),
              iconSize: Core__Option.map(props.iconSize, Units.string_of_length),
              iconMarginTop: Core__Option.map(props.iconMarginTop, Units.string_of_length),
              itemSpacing: Core__Option.map(props.itemSpacing, Units.string_of_length)
            });
}

var make$1 = List__Jsx3;

exports.colorFromType = colorFromType;
exports.JS = JS;
exports.make = make$1;
/* make Not a pure module */
